import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Utils } from '@app-shared/utils';

@Component({
	selector: 'app-chart-legend',
	templateUrl: './chart-legend.component.html',
	styleUrls: ['./chart-legend.component.scss']
})
export class ChartLegendComponent {
	@Output() submit = new EventEmitter<{ label: string; data: number }>();
	@Output() restoreFilter = new EventEmitter<null>();

	@Input() legends: string[];
	@Input() buildingPDF: boolean;
	@Input() datasets;
	@Input() colors: string[] | null = null;

	@Input() clearFilter: boolean = false;

	constructor() {}

	ngOnInit() {}

	public getLegendColor(index: number): string {
		if (this.colors && this.colors[index]) {
			return this.colors[index];
		}
		return Utils.getColorByIndex(index);
	}
}
